<div *ngIf="rentIncomeAvailable" class="container" [ngClass]="printActive ? 'return-view-background-print' : 'return-view-background'" style="margin-top: 60px; page-break-inside: avoid;">
    <div class="row">
        <div class="col-sm-12 text-center font-weight-bold">
            তফসিল ২
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 text-center">
            ভাড়া হইতে আয় থাকিলে নিম্নোক্ত তফসিলটি পূরণ করিতে হইবে
        </div>
    </div>
    <div class="row my-5">
        <div class="col-sm-5">করদাতার নাম: {{returnData?.profileData?.assesName}}</div>
        <div class="col-sm-7 text-right">
            টি আইএন: 
            <span class="ml-3" style="white-space: nowrap;">
                <input value="{{item | convertNumWithOtherCharsToBn}}" *ngFor="let item of returnData?.profileData?.tin.split('')" class="input-default" disabled/>
            </span>            
        </div>
    </div>
    <div class="row mt-5 mb-5">
        <div class="col-sm-12">
            <div class="row bt bb">
                <div class="col-sm-3 text-center bl br pt-1 pb-2">সম্পত্তির অবস্থান, বিবরণ ও মালিকানার অংশ</div>
                <div class="col-sm-9">
                    <div class="row h-100">
                        <div class="col-sm-6 text-center br pt-1 pb-2">মোট ভাড়া মূল্য পরিগণনা</div>
                        <div class="col-sm-3 text-center br pt-1 pb-2">টাকার পরিমাণ</div>
                        <div class="col-sm-3 text-center br pt-1 pb-2">টাকার পরিমাণ</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 bl br bb pt-1 pb-2">    
                    <div class="mb-1" *ngFor="let value of returnData?.headSummery?.rentDetailsSummery?.propertyDetails">{{value}}</div>               
                </div>
                <div class="col-sm-9 rent-income-table">
                    <div class="row">
                        <div class="col-sm-6 bb br">১। প্রাপ্ত ভাড়ার পরিমাণ বা বার্ষিক মূল্য, এই দুইয়ের মধ্যে যাহা অধিক</div>
                        <div class="col-sm-3 bb br">{{greaterOfRentAndAnnual | formatNumberReturnView}}</div>
                        <div class="col-sm-3 br"></div>
                    </div>                    
                    <div class="row">
                        <div class="col-sm-6 bb br">২। প্রাপ্ত অগ্রীম ভাড়া</div>
                        <div class="col-sm-3 bb br"></div>
                        <div class="col-sm-3 br"></div>
                    </div>   
                    <div class="row">
                        <div class="col-sm-6 bb br">৩। প্রাপ্ত যেকোন অঙ্ক বা সুবিধার অর্থমূল্য (১ ও ২ এ উল্লিখিত অঙ্কের অতিরিক্ত)</div>
                        <div class="col-sm-3 bb br">{{valueOfAnyBenefit | formatNumberReturnView}}</div>
                        <div class="col-sm-3 br"></div>
                    </div>   
                    <div class="row">
                        <div class="col-sm-6 bb br">৪। সমন্বয়কৃত অগ্রিম অঙ্ক</div>
                        <div class="col-sm-3 bb br">{{advanceAdjustmentAmount | formatNumberReturnView}}</div>
                        <div class="col-sm-3 br"></div>
                    </div>   
                    <div class="row">
                        <div class="col-sm-6 bb br">৫। শূন্যতা ভাতা</div>
                        <div class="col-sm-3 bb br">{{data?.vacancyAllowanceAmount | formatNumberReturnView}}</div>
                        <div class="col-sm-3 bb br"></div>
                    </div>  

                    <div class="row">
                        <div class="col-sm-9 bb br">৬। মোট ভাড়ামূল্য</div>                        
                        <div class="col-sm-3 bb br">{{totalRentValue | formatNumberReturnView}}</div>
                    </div>   
                    
                    <div class="row">
                        <div class="col-sm-9 bb br">৭। অনুমোদনযোগ্য বিয়োজনসমূহ</div>
                        <div class="col-sm-3 br">
                            {{
                                (data?.repairCollection + data?.municipalLocalTaxOrLandRevenue
                                 + data?.interestOnLoanMortgageCapital 
                                 + data?.insurancePremium + data?.other) | formatNumberReturnView
                            }}
                        </div>                        
                    </div>
                   
                    <div class="row">
                        <div class="col-sm-6 bb br">(ক) মেরামত আদায় ইত্যাদি</div>
                        <div class="col-sm-3 bb br">{{data?.repairCollection | formatNumberReturnView}}</div>
                        <div class="col-sm-3 br"></div>
                    </div>    
                    <div class="row">
                        <div class="col-sm-6 bb br">(খ) পৌর কর অথবা স্থানীয় কর</div>
                        <div class="col-sm-3 br">{{data?.municipalLocalTaxOrLandRevenue | formatNumberReturnView}}</div>
                        <div class="col-sm-3 br"></div>
                    </div>    
                    <div class="row">
                        <div class="col-sm-6 bb br">(গ) ভূমি রাজস্ব</div>
                        <div class="col-sm-3 bb br"></div>
                        <div class="col-sm-3 br"></div>
                    </div>    
                    <div class="row">
                        <div class="col-sm-6 bb br">(ঘ) পরিশোধিত ঋণের উপর সূদ/ বন্ধকী/ মূলধনি চার্জ</div>
                        <div class="col-sm-3 bb br">{{data?.interestOnLoanMortgageCapital | formatNumberReturnView}}</div>
                        <div class="col-sm-3 br"></div>
                    </div>    
                    <div class="row">
                        <div class="col-sm-6 bb br">(ঙ) পরিশোধিত বিমা প্রিমিয়াম</div>
                        <div class="col-sm-3 bb br">{{data?.insurancePremium | formatNumberReturnView}}</div>
                        <div class="col-sm-3 br"></div>
                    </div>    
                    <div class="row">
                        <div class="col-sm-6 bb br">(চ) অন্যান্য (যদি থাকে)</div>
                        <div class="col-sm-3 bb br">{{ otherIncome | formatNumberReturnView}}</div>
                        <div class="col-sm-3 br bb"></div>
                    </div>    

                    <div class="row">
                        <div class="col-sm-9 bb br">৮। মোট অনুমোদনযোগ্য বিয়োজন</div>
                        <div class="col-sm-3 bb br">{{data?.allowableDeduction | formatNumberReturnView}}</div>                        
                    </div>  
                    <div class="row">
                        <div class="col-sm-9 bb br">৯। নীট আয় (ক্রমিক ৬ হইতে ক্রমিক ৮ এর বিয়োগফল)</div>
                        <div class="col-sm-3 bb br">{{ netIncomeFromRent | formatNumberReturnView}}</div>                        
                    </div>  
                    <div class="row">
                        <div class="col-sm-9 bb br">১০। করদাতার অংশ (প্রযোজ্য ক্ষেত্রে)</div>
                        <div class="col-sm-3 bb br"></div>                        
                    </div>  
                    <div class="row">
                        <div class="col-sm-9 bb br">১১। বিশেষ ভাড়া আয়</div>
                        <div class="col-sm-3 bb br">{{data?.specialRentalIncome | formatNumberReturnView}}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-9 bb br">১২। মোট ভাড়া আয় (৯ + ১১)</div>
                        <div class="col-sm-3 bb br">{{totalRentalIncome | formatNumberReturnView}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
